import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div data-testid="auth-loading" className="min-h-screen flex items-center justify-center">
        <div className="font-mono text-xs tracking-[0.3em] uppercase text-novya-muted">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
